<template>
  <div class="help-img" @click="goToHelpPage">
    <img src="/assets/img/support.svg" />
    <p>Help?</p>
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
export default {
  name: 'HelpCenter',
  methods: {
    goToHelpPage() {
      window.open(`${Config.SOCO_WEB_URL}/page/help`, '_blank');
    },
  },
};
</script>

<style scoped>
.help-img {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  @media (max-width: 768px) {
    margin-top: 0px;
  }
}

.help-img img {
  width: 20px;
  height: 20px;
}

.help-img p {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: #eb395f;
}

.help-img:hover {
  opacity: 0.8;
}
</style>
